class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });

  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartUpsellComponent extends HTMLElement {
  constructor() {
    super();
    console.log(this.querySelector('.button[data-add-to-cart]'))
    this.querySelector('.button[data-add-to-cart]').addEventListener('click', (event) => {
      event.preventDefault();
      this.removeOldUpsellAndAddUpsell(event.target.dataset.productId, this.querySelector('.button[data-add-to-cart]'));
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble'
      },
    ];
  }

  getSectionInnerHTML(html, selector=".shopify-section") {
    console.log(new DOMParser().parseFromString(html, 'text/html'))
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  removeOldUpsellAndAddUpsell(id, buttonDom) {
    // Select all upsell elements in the cart
    const upsellItems = document.querySelector('.cart-item.is-upsell');
    console.log("uuuuuuuuuu", upsellItems);
    if (!upsellItems) {
      this.addUpsell(id);
      return;
    }
      // Loop through each upsell item

    // const removeButton = upsellItems.querySelector('cart-remove-button');
    // if (removeButton) {
    //   const index = removeButton.dataset.index;

    //   // Send AJAX request to remove the upsell item
    //   const body = JSON.stringify({
    //     line: index,
    //     quantity: 0,
    //     sections: this.getSectionsToRender().map((section) => section.section),
    //     sections_url: window.location.pathname,
    //   });

    //   fetch(`${routes.cart_change_url}`, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Accept': 'application/json',
    //     },
    //     body,
    //   })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error(`Failed to remove upsell item with index ${index}`);
    //     }
    //     return response.text();
    //   })
    //   .then((state) => {
    //     const parsedState = JSON.parse(state);

    //     // Update the cart sections
    //     this.getSectionsToRender().forEach((section) => {
    //       const sectionElement = section.selector
    //         ? document.querySelector(section.selector)
    //         : document.getElementById(section.id);

    //       if (sectionElement && parsedState.sections?.[section.section]) {
    //         sectionElement.innerHTML = this.getSectionInnerHTML(
    //           parsedState.sections[section.section],
    //           section.selector
    //         );
    //       }
    //     });

    //     // Remove the upsell DOM element
    //     upsellItems.remove();
        this.addUpsell(id);
    //   })
    //   .catch((error) => {
    //     console.error('Error removing upsell item:', error);
    //   });
    // }

    console.log(buttonDom.closest('upsell-component'), "buttonDom.closest('upsell-component')");
    buttonDom.closest('upsell-component').remove();
  }

  addUpsell(id) {
    const addButton = this.querySelector(`[data-product-id="${id}"]`);
    if (addButton) {
      addButton.classList.add('loading');
      addButton.disabled = true;
    }

    const maxRetries = 3;
    const baseDelay = 1000;

    const attemptAdd = (retryCount = 0) => {
      const body = JSON.stringify({
        'items': [{
          id,
          'quantity': 1
        }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{ body },
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      })
      .then(async (response) => {
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('Server returned non-JSON response');
        }
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
        }
        
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error('Failed to parse response:', state);
          throw new Error('Invalid JSON response from server');
        }
        
        if (parsedState.errors || parsedState.items?.length === 0) {
          console.error('Cart errors:', parsedState.errors);
          throw new Error(parsedState.errors || 'Failed to add item to cart');
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          
          if (sectionElement && parsedState.sections?.[section.id]) {
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        });

        // Check and apply free shipping discount after adding upsell
        // Access CartItems element to check discount
        const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        if (cartItemsElement && typeof cartItemsElement.checkAndApplyFreeShippingDiscount === 'function') {
          cartItemsElement.checkAndApplyFreeShippingDiscount(parsedState);
        }

        new Swiper(".upsell-product-swiper-contianer", {
          loop: true,
          autoplay: {
            delay: 3000, // time in ms (3 seconds)
            disableOnInteraction: false, // keep autoplay running after swipe
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        if (addButton) {
          addButton.classList.remove('loading');
          addButton.disabled = false;
        }
      })
      .catch((error) => {
        console.error('Add to cart error:', error.message);
        
        if (retryCount < maxRetries) {
          const delay = baseDelay * Math.pow(2, retryCount);
          console.log(`Retrying in ${delay}ms... (attempt ${retryCount + 1} of ${maxRetries})`);
          setTimeout(() => {
            attemptAdd(retryCount + 1);
          }, delay);
        } else {
          if (addButton) {
            addButton.classList.remove('loading');
            addButton.disabled = false;
          }
          
          const errorMessage = document.createElement('div');
          errorMessage.classList.add('cart-error-message');
          errorMessage.textContent = 'Failed to add item to cart. Please try again.';
          if (addButton?.parentElement) {
            addButton.parentElement.appendChild(errorMessage);
          }
          
          setTimeout(() => {
            errorMessage.remove();
          }, 3000);
        }
      });
    };

    attemptAdd();
  }
}

customElements.define('upsell-component', CartUpsellComponent);



class CartItems extends HTMLElement {
  constructor() {
    super();
    console.log(this.querySelector('.quantity__input'))
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.querySelectorAll('.quantity__input').forEach(element => {
      element.addEventListener('change', debouncedOnChange.bind(this));
    });

    if (this.querySelector('.upgrade-sbuscribe') != undefined) {
      this.querySelectorAll('.upgrade-sbuscribe').forEach(element => {
        element.addEventListener('click', this.UpgradeToSubscribeButton.bind(this));
      });
    }
    if (this.querySelector('.upgrade-subscribe-dropdown') != undefined) {
      this.querySelectorAll('.upgrade-subscribe-dropdown').forEach(element => {
        element.addEventListener('change', this.UpgradeToSubscribeDropdown.bind(this));
      });
    }

    // Skip updateTiredBar in constructor if we're already adding a gift
    // This prevents cascading updates when the element is recreated during addFreeGift
    if (!CartItems.globalIsAddingFreeGift) {
      this.updateTiredBar();
    }
  }

  cartUpdateUnsubscriber = undefined;
  updateTiredBarTimeout = null;
  isAddingFreeGift = false;
  isApplyingDiscount = false;
  static globalIsAddingFreeGift = false; // Shared flag across all instances
  lastCartData = null; // Store last cart data for accurate total
  lastLoggedGiftConfigSignature = '';

  getGiftConfig() {
    const defaultGiftVariantId = parseInt(this.dataset.freeGiftBeforeShippingDefault, 10);
    const validDefaultGiftVariantId = Number.isFinite(defaultGiftVariantId) && defaultGiftVariantId > 0
      ? defaultGiftVariantId
      : null;

    const allGiftVariantIdsSet = new Set();
    const allGiftIdsRaw = String(this.dataset.freeGiftBeforeShippingAll || '');
    allGiftIdsRaw
      .split(',')
      .map((value) => parseInt(value.trim(), 10))
      .filter((value) => Number.isFinite(value) && value > 0)
      .forEach((value) => allGiftVariantIdsSet.add(value));

    if (validDefaultGiftVariantId) {
      allGiftVariantIdsSet.add(validDefaultGiftVariantId);
    }

    const freeshipProductGiftMap = new Map();
    const freeshipMapRaw = String(this.dataset.freeshipProductGiftMap || '');
    freeshipMapRaw
      .split(',')
      .map((pair) => pair.trim())
      .filter(Boolean)
      .forEach((pair) => {
        const [productIdRaw, giftIdRaw] = pair.split(':');
        const productId = parseInt(productIdRaw, 10);
        const giftVariantId = parseInt(giftIdRaw, 10);
        if (Number.isFinite(productId) && productId > 0 && Number.isFinite(giftVariantId) && giftVariantId > 0) {
          freeshipProductGiftMap.set(productId, giftVariantId);
          allGiftVariantIdsSet.add(giftVariantId);
        }
      });

    const freeshipProductIdsSet = new Set();
    if (freeshipProductGiftMap.size > 0) {
      freeshipProductGiftMap.forEach((_, productId) => freeshipProductIdsSet.add(productId));
    } else {
      String(this.dataset.freeshipProductIds || this.dataset.freeshipProductId || '')
        .split(',')
        .map((value) => parseInt(value.trim(), 10))
        .filter((value) => Number.isFinite(value) && value > 0)
        .forEach((value) => freeshipProductIdsSet.add(value));
    }

    const defaultGiftThresholdRaw = parseInt(this.dataset.limitbeforeShipping1, 10);
    const defaultGiftThreshold = Number.isFinite(defaultGiftThresholdRaw) ? defaultGiftThresholdRaw : 0;
    const freeshipGiftThresholdRaw = parseInt(this.dataset.limitbeforeShipping1Freeship, 10);
    const freeshipGiftThreshold = Number.isFinite(freeshipGiftThresholdRaw)
      ? freeshipGiftThresholdRaw
      : defaultGiftThreshold;

    const allGiftVariantIds = Array.from(allGiftVariantIdsSet);
    const freeshipProductGiftEntries = Array.from(freeshipProductGiftMap.entries());
    const debugSignature = JSON.stringify({
      defaultGiftVariantId: validDefaultGiftVariantId,
      allGiftVariantIds,
      freeshipProductGiftEntries,
      defaultGiftThreshold,
      freeshipGiftThreshold,
    });

    if (this.lastLoggedGiftConfigSignature !== debugSignature) {
      this.lastLoggedGiftConfigSignature = debugSignature;
      console.log('[Gift config from settings]', {
        defaultGiftVariantId: validDefaultGiftVariantId,
        allGiftVariantIds,
        freeshipProductGiftMap: freeshipProductGiftEntries,
        defaultGiftThreshold,
        freeshipGiftThreshold,
      });
    }

    return {
      defaultGiftVariantId: validDefaultGiftVariantId,
      allGiftVariantIdsSet,
      freeshipProductGiftMap,
      freeshipProductIdsSet,
      defaultGiftThreshold,
      freeshipGiftThreshold,
    };
  }

  calculateTotalWithoutGiftItems(items = []) {
    const { allGiftVariantIdsSet } = this.getGiftConfig();
    return items.reduce((total, item) => {
      if (allGiftVariantIdsSet.has(item.variant_id)) {
        return total;
      }
      return total + (item.final_line_price || item.original_line_price || 0);
    }, 0);
  }


  connectedCallback() {
    // Skip if we're currently adding a gift (prevents re-initialization during DOM updates)
    if (CartItems.globalIsAddingFreeGift) {
      return;
    }

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log(event.source)
      if (event.source === 'cart-items') {
        // Store cart data for accurate total calculation
        if (event.cartData) {
          this.lastCartData = event.cartData;
        }
        // Always call updateTiredBar - it will handle removal if needed
        // Only skip if we're actively adding (not removing)
        if (!CartItems.globalIsAddingFreeGift) {
          this.updateTiredBar(event.cartData);
        }
        this.checkAndApplyFreeShippingDiscount(event.cartData);
        return;
      }
      
      this.onCartUpdate();
    });
    
    // Check discount on initial load
    this.checkAndApplyFreeShippingDiscount();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.updateTiredBarTimeout) {
      clearTimeout(this.updateTiredBarTimeout);
    }
  }

  UpgradeToSubscribeDropdown(event) {
    event.preventDefault();
    console.log(event);
    var line = event.target.dataset.index;
    var sellingPlan = event.target.value == 'One-time purchase'? '': event.target.value ;
    console.log(sellingPlan)
    var variantId = event.target.variantId;
    this.UpdateSellingPlan(line, sellingPlan, variantId);
  }

  UpgradeToSubscribeButton(event) {
    event.preventDefault();
    console.log(event);
    var line = event.target.dataset.index;
    var sellingPlan = event.target.dataset.sellingPlanId;
    var variantId = event.target.variantId;
    this.UpdateSellingPlan(line, sellingPlan, variantId);
  }

  updateTiredBar(cartData = null) {
    console.log("updateTierBar...");
    // Skip if already adding a gift
    if (CartItems.globalIsAddingFreeGift) {
      return;
    }
    // Clear any pending timeout to prevent duplicate executions
    if (this.updateTiredBarTimeout) {
      clearTimeout(this.updateTiredBarTimeout);
    }

    // Store latest cart data
    if (cartData) {
      this.lastCartData = cartData;
    }

    // Ensure we have authoritative cart data before deciding gift actions
    if (!this.lastCartData || !Array.isArray(this.lastCartData.items)) {
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((freshCart) => {
          if (!CartItems.globalIsAddingFreeGift) {
            this.updateTiredBar(freshCart);
          }
        })
        .catch((error) => {
          console.error('Failed to fetch cart data for gift logic:', error);
        });
      return;
    }

    const {
      defaultGiftVariantId,
      allGiftVariantIdsSet,
      freeshipProductGiftMap,
      freeshipProductIdsSet,
      defaultGiftThreshold,
      freeshipGiftThreshold,
    } = this.getGiftConfig();
    this.FreeGiftBeforeShipping1 = defaultGiftThreshold;
    // this.FreeGiftLimit1 = parseInt(this.dataset['limit-2']);
    this.FreeGiftLimit1 = 20000;
    this.FreeGiftLimit2 = parseInt(this.dataset.giftLimit);

    // const classCombinedList = ['.cart-item.free-gift-before-shipping-1', '.cart-item.free-gift-1', '.cart-item.free-gift-2'];

    this.total = parseInt(this.dataset.total) || 0;

    this.updateTiredBarTimeout = setTimeout(() => {
      // Skip if already adding a gift
      if (this.isAddingFreeGift || CartItems.globalIsAddingFreeGift) {
        return;
      }
      const effectiveCartData = this.lastCartData;
      if (!effectiveCartData || !Array.isArray(effectiveCartData.items)) {
        return;
      }

      // Calculate total excluding gift lines from authoritative cart data
      const nonGiftTotal = this.calculateTotalWithoutGiftItems(effectiveCartData.items);
      this.dataset.total = String(nonGiftTotal);
      const currentTotal = nonGiftTotal;

      const freeshipCartItem = effectiveCartData.items.find((item) => freeshipProductIdsSet.has(item.product_id));
      const hasFreeshipProductInCart = Boolean(freeshipCartItem);
      const mappedFreeshipGiftVariantId = freeshipCartItem ? freeshipProductGiftMap.get(freeshipCartItem.product_id) : null;
      const targetGiftVariantId = mappedFreeshipGiftVariantId || defaultGiftVariantId;
      const activeGiftThreshold = hasFreeshipProductInCart ? freeshipGiftThreshold : defaultGiftThreshold;

      const giftLineItems = effectiveCartData.items
        .map((item, index) => ({ item, line: index + 1 }))
        .filter(({ item }) => allGiftVariantIdsSet.has(item.variant_id));

      console.log('Gift enforcement check', {
        threshold: activeGiftThreshold,
        activeGiftThreshold,
        currentTotal,
        hasFreeshipProductInCart,
        mappedFreeshipGiftVariantId,
        targetGiftVariantId,
        giftCount: giftLineItems.length,
      });

      // Rule 1: below threshold => no gift line should exist
      if (activeGiftThreshold > currentTotal) {
        if (giftLineItems.length > 0) {
          this.updateQuantity(giftLineItems[0].line, 0);
        }
        return;
      }

      // Rule 2: threshold met => exactly one target gift line with quantity 1
      if (!targetGiftVariantId) {
        if (giftLineItems.length > 0) {
          this.updateQuantity(giftLineItems[0].line, 0);
        }
        return;
      }

      const wrongGiftLines = giftLineItems.filter(({ item }) => item.variant_id !== targetGiftVariantId);
      if (wrongGiftLines.length > 0) {
        this.updateQuantity(wrongGiftLines[0].line, 0);
        return;
      }

      const targetGiftLines = giftLineItems.filter(({ item }) => item.variant_id === targetGiftVariantId);
      if (targetGiftLines.length > 1) {
        this.updateQuantity(targetGiftLines[1].line, 0);
        return;
      }

      if (targetGiftLines.length === 1 && targetGiftLines[0].item.quantity !== 1) {
        this.updateQuantity(targetGiftLines[0].line, 1);
        return;
      }

      if (targetGiftLines.length === 0) {
        if (!this.isAddingFreeGift && !CartItems.globalIsAddingFreeGift) {
          if (this.updateTiredBarTimeout) {
            clearTimeout(this.updateTiredBarTimeout);
            this.updateTiredBarTimeout = null;
          }
          this.isAddingFreeGift = true;
          CartItems.globalIsAddingFreeGift = true;
          this.addFreeGift([{ id: targetGiftVariantId, quantity: 1 }]);
        }
      }
      
      if (this.FreeGiftLimit2 > this.total) {
        if (this.querySelector('.cart-item.free-gift-2') != undefined) {
          this.removeFreeGift(this.querySelector('.cart-item.free-gift-2'));
          return;
        }
      } else {
        // if (this.querySelector('.cart-item.free-gift-2') == undefined) {
        //   this.addFreeGift([
        //     { id: secondProduct, quantity: 1 }
        //   ]);
        //   return;
        // }
      }

      // if (this.FreeGiftLimit1 > this.total) {
      //   if (this.querySelector('.cart-item.free-gift-1') != undefined) {
      //     this.removeFreeGift(this.querySelector('.cart-item.free-gift-1'));
      //     return;
      //   }
      //   if (this.querySelector('.cart-item.free-gift-2') != undefined) {
      //     this.removeFreeGift(this.querySelector('.cart-item.free-gift-2'));
      //     return;
      //   }
      // } else if (this.FreeGiftLimit1 <= this.total && this.FreeGiftLimit2 > this.total) {
      //   if (this.querySelector('.cart-item.free-gift-2') != undefined) {
      //     this.removeFreeGift(this.querySelector('.cart-item.free-gift-2'));
      //     return;
      //   }
      //   if (this.querySelector('.cart-item.free-gift-1') == undefined) {
      //     this.addFreeGift([
      //       { id: firstProduct, quantity: 1 }
      //     ]);
      //     return;
      //   }
      // } else if (this.FreeGiftLimit2 <= this.total) {
      //   if (this.querySelector('.cart-item.free-gift-1') == undefined) {
      //     this.addFreeGift([
      //       { id: firstProduct, quantity: 1 }
      //     ]);
      //     return;
      //   }
      //   if (this.querySelector('.cart-item.free-gift-2') == undefined) {
      //     this.addFreeGift([
      //       { id: secondProduct, quantity: 1 }
      //     ]);
      //     return;
      //   }
      // }
    }, 700)
  }

  removeFreeGift(element) {
    if (!element) {
      console.warn('removeFreeGift called with null element');
      return;
    }
    const removeButton = element.querySelector('cart-remove-button');
    if (!removeButton) {
      console.warn('removeFreeGift: no remove button found in element');
      return;
    }
    const index = removeButton.dataset.index;
    if (!index) {
      console.warn('removeFreeGift: no index found on remove button');
      return;
    }
    console.log('removeFreeGift: removing item at index', index);
    this.updateQuantity(index, 0);
  }



  addFreeGift(productIds) {
    const variantIdToAdd = productIds[0]?.id;
    if (!variantIdToAdd) {
      this.isAddingFreeGift = false;
      CartItems.globalIsAddingFreeGift = false;
      return;
    }

    // Authoritative safety check: avoid adding if this gift already exists in cart data
    if (this.lastCartData && Array.isArray(this.lastCartData.items)) {
      const alreadyExists = this.lastCartData.items.some((item) => item.variant_id === variantIdToAdd);
      if (alreadyExists) {
        this.isAddingFreeGift = false;
        CartItems.globalIsAddingFreeGift = false;
        return;
      }
    }

    // DOM fallback check
    const giftExistsInDom = this.querySelector(`cart-remove-button[data-variant-id="${variantIdToAdd}"]`);
    if (giftExistsInDom) {
      this.isAddingFreeGift = false;
      CartItems.globalIsAddingFreeGift = false;
      return;
    }

    // If flag is already set (by caller), we're good to proceed
    // If not set, set it now to prevent concurrent additions
    if (!this.isAddingFreeGift) {
      this.isAddingFreeGift = true;
    }
    if (!CartItems.globalIsAddingFreeGift) {
      CartItems.globalIsAddingFreeGift = true;
    }

    const body = JSON.stringify({
      'items': productIds,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const items = document.querySelectorAll('.cart-item');
      console.log(parsedState.errors)
      if (parsedState.errors || parsedState.items.length == 0 ) {
        console.log(parsedState)
        return;
      }
      this.lastCartData = parsedState;
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      // Keep data-total synchronized (excluding gift line amounts)
      const totalWithoutGifts = this.calculateTotalWithoutGiftItems(parsedState.items || []);
      this.dataset.total = String(totalWithoutGifts);

      // Check and apply free shipping discount after adding free gift
      this.checkAndApplyFreeShippingDiscount(parsedState);

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
    })
    .catch((error) => {
      console.error('Error adding free gift:', error);
    })
    .finally(() => {
      // Reset flags after operation completes with a small delay
      // This ensures DOM updates have settled and prevents recreated elements from triggering updates
      setTimeout(() => {
        this.isAddingFreeGift = false;
        CartItems.globalIsAddingFreeGift = false;
      }, 100);
    });
  }

  UpdateSellingPlan(line, sellingPlan, variantId) {
    
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      "selling_plan": sellingPlan,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      // Store cart data for accurate total calculation
      this.lastCartData = parsedState;
      
      if (this.dataset.total !== undefined) {
        const totalWithoutGifts = this.calculateTotalWithoutGiftItems(parsedState.items || []);
        this.dataset.total = totalWithoutGifts > 0
          ? totalWithoutGifts.toString()
          : String(parsedState.total_price || 0);
      }

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
      }

      // Store cart data for accurate total calculation
      this.lastCartData = parsedState;
      
      if (this.dataset.total !== undefined) {
        const totalWithoutGifts = this.calculateTotalWithoutGiftItems(parsedState.items || []);
        this.dataset.total = totalWithoutGifts > 0
          ? totalWithoutGifts.toString()
          : String(parsedState.total_price || 0);
      }
      
      // Check and apply free shipping discount after updating selling plan
      this.checkAndApplyFreeShippingDiscount(parsedState);

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
    })
    .catch(() => {
      this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    });
  }

  onChange(event) {
    console.log(event)
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    console.log("line", line);
    this.enableLoading(line);
    console.log(this.getSectionsToRender().map((section) => section.section))
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    console.log("body----", body);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        
        const { allGiftVariantIdsSet } = this.getGiftConfig();
        const totalWithoutGifts = this.calculateTotalWithoutGiftItems(parsedState.items || []);
        this.dataset.total = totalWithoutGifts > 0
          ? totalWithoutGifts.toString()
          : String(parsedState.total_price || 0);
        console.log('Updated data-total after cart update:', {
          oldTotal: this.total,
          newTotal: totalWithoutGifts,
          itemCount: parsedState.items?.length || 0,
          giftItemsRemoved: parsedState.items?.filter((item) =>
            allGiftVariantIdsSet.has(item.variant_id)
          ).length || 0,
        });
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        
        // Store cart data for accurate total calculation
        this.lastCartData = parsedState;
        
        // Check and apply free shipping discount after cart update
        this.checkAndApplyFreeShippingDiscount(parsedState);
        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        console.log(window.cartStrings.error)
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  checkAndApplyFreeShippingDiscount(cartData = null) {
    // Prevent duplicate operations
    if (this.isApplyingDiscount) {
      return;
    }

    const freeshipProductId = this.dataset.freeshipProductId;
    const freeshipDiscountCode = this.dataset.freeshipDiscountCode;
    
    if (!freeshipProductId || !freeshipDiscountCode) {
      return; // No product or discount code configured for free shipping discount
    }

    // Get cart data if not provided
    if (!cartData) {
      fetch(`${routes.cart_url}.js`)
        .then(response => response.json())
        .then(cart => {
          this.applyFreeShippingDiscountLogic(cart, freeshipProductId, freeshipDiscountCode);
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
        });
      return;
    }

    this.applyFreeShippingDiscountLogic(cartData, freeshipProductId, freeshipDiscountCode);
  }

  applyFreeShippingDiscountLogic(cartData, freeshipProductId, freeshipDiscountCode) {
    if (!cartData || !cartData.items) {
      return;
    }

    // Validate freeshipProductId - must be a valid number
    const productIdNum = parseInt(freeshipProductId, 10);
    if (!freeshipProductId || isNaN(productIdNum) || productIdNum <= 0) {
      // Invalid product ID, ensure discount is removed if present
      const hasDiscount = cartData.cart_level_discount_applications?.some(
        discount => discount.title === freeshipDiscountCode || discount.code === freeshipDiscountCode
      );
      if (hasDiscount) {
        this.removeDiscountCode();
      }
      return;
    }

    // Check if the specific product is in the cart (strict comparison)
    const hasProduct = cartData.items.some(item => {
      return item.product_id === productIdNum;
    });

    // Check if discount is already applied (check by code or title)
    const hasDiscount = cartData.cart_level_discount_applications?.some(
      discount => discount.title === freeshipDiscountCode || discount.code === freeshipDiscountCode
    );

    // Apply or remove discount based on product presence
    if (hasProduct && !hasDiscount) {
      this.applyDiscountCode(freeshipDiscountCode);
    } else if (!hasProduct && hasDiscount) {
      this.removeDiscountCode();
    }
  }

  applyDiscountCode(discountCode) {
    if (this.isApplyingDiscount) {
      return;
    }

    this.isApplyingDiscount = true;

    // Shopify uses /discount/{code} endpoint to apply discount codes
    // This endpoint redirects, so we use redirect: 'follow' and don't check response.ok
    fetch(`/discount/${discountCode}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
      credentials: 'same-origin',
      redirect: 'follow',
    })
      .then(() => {
        // Wait a bit for the discount to be applied server-side
        return new Promise(resolve => setTimeout(resolve, 500));
      })
      .then(() => {
        // After applying discount, fetch updated cart with sections
        const sectionsParam = this.getSectionsToRender().map((section) => section.section).join(',');
        return fetch(`${routes.cart_url}?sections=${sectionsParam}`);
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch updated cart: ${response.status}`);
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        // Update cart sections
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          
          if (sectionElement && parsedState.sections?.[section.section]) {
            sectionElement.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        // Fetch cart data for event
        return fetch(`${routes.cart_url}.js`);
      })
      .then((response) => response.json())
      .then((cartData) => {
        // Publish cart update event
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartData });
      })
      .catch((error) => {
        console.error('Error applying discount code:', error);
      })
      .finally(() => {
        this.isApplyingDiscount = false;
      });
  }

  removeDiscountCode() {
    if (this.isApplyingDiscount) {
      return;
    }

    this.isApplyingDiscount = true;

    // In Shopify, to remove a discount, we need to clear it
    // The discount is stored in the cart, so we'll fetch the cart and update sections
    // The discount will be automatically removed when the product is removed
    // For now, just refresh the cart sections to reflect current state
    const sectionsParam = this.getSectionsToRender().map((section) => section.section).join(',');
    fetch(`${routes.cart_url}?sections=${sectionsParam}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch updated cart: ${response.status}`);
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        // Update cart sections
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          
          if (sectionElement && parsedState.sections?.[section.section]) {
            sectionElement.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        // Fetch cart data for event
        return fetch(`${routes.cart_url}.js`);
      })
      .then((response) => response.json())
      .then((cartData) => {
        // Publish cart update event
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartData });
      })
      .catch((error) => {
        console.error('Error removing discount code:', error);
      })
      .finally(() => {
        this.isApplyingDiscount = false;
      });
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}